<template>
  <hm-content>
    <el-table
      stripe
      ref="attrTable"
      :data="attributeDetails.records"
      style="width: 100%"
      id="table"
      size="small"
      border
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column header-align="center" align="center" prop="typeName" label="属性类型"></el-table-column>
      <el-table-column header-align="center" align="center" prop="attributeName" label="属性名称"></el-table-column>
      <el-table-column header-align="center" align="center"  label="属性值录入方式">
        <template slot-scope="scope">
          <span v-if="scope.row.valueType === 'select'">下拉选框</span>
          <span v-else>录入文本</span>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="valueName" label="属性值列表"></el-table-column>
    </el-table>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="attributeDetails.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-sizes="[10, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10
    };
  },
  computed: mapGetters(["attributeDetails"]),
  watch: {},
  created() {
    this.$store.dispatch("queryAttributeDetails", {
      typeId: this.$route.query.id,
      pageSize: this.pageSize,
      pageNo: this.currentPage
    });
  },
  mounted() {},
  methods: {
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList(){
      this.$store.dispatch("queryAttributeDetails", {
        typeId: this.$route.query.id,
        pageSize: this.pageSize,
        pageNo: this.currentPage
      });
    },
  }
};
</script>
<style lang="scss" scoped>
</style>
